<template>
  <div class="page currency-page">
    <div class="header">
      <div class="title">
        Валюты
      </div>
    </div>
    <div class="content">
      <el-card shadow="always" class="main-card" v-loading="loadingStatus">
        <div slot="header">
          <div>
            <el-button
              v-if="session.type === 1 || session.type === -1"
              @click.prevent="addValute()"
              type="success"
              class="add-btn bottom-space"
              >Добавить валюту</el-button
            >
            <el-button
              @click.prevent="queryPaginationValutes()"
              type="primary"
              class="add-btn bottom-space"
              >Обновить</el-button>
          </div>
          <div>
            <el-form ref="form">
              <el-row :span="24">
                <el-col :xs="24" :sm="24" :md="16" :lg="14" :xl="10">
                  <el-form-item>
                    <el-tooltip
                      placement="top"
                      content="Поиск по названию и ключу"
                    >
                      <el-input
                        class="bottom-space"
                        prefix-icon="el-icon-search"
                        placeholder="Введите и нажмите Enter"
                        v-model="searchStringFilter"
                        @change="performSearch"
                        clearable
                      >
                        <el-button
                          slot="append"
                          icon="el-icon-search"
                        ></el-button>
                      </el-input>
                    </el-tooltip>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item>
                <el-tooltip placement="top">
                  <div slot="content">Фильтр по категории валюты</div>
                  <el-select
                    class="bottom-space"
                    placeholder="Тип валюты"
                    clearable
                    filterable
                    v-model="categoryFilter"
                  >
                    <el-option
                      v-for="item in this.categories"
                      :key="item.name"
                      :label="item.name"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-tooltip>
                <el-tooltip placement="top">
                  <div slot="content">Фильтр активности</div>
                  <el-select
                    class="bottom-space"
                    placeholder="Активность"
                    clearable
                    filterable
                    v-model="activeFilter"
                  >
                    <el-option
                      v-for="item in activeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>
              <el-form-item>
                <el-button
                  class="bottom-space"
                  v-if="isFiltered"
                  type="danger"
                  @click="resetSearch"
                  >Сбросить фильтры</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div v-if="typeof valutes.docs !== 'undefined' && valutes.docs.length">
          <el-table
            @sort-change="handleSortChange"
            :default-sort="{ prop: 'title', order: 'descending' }"
            :data="valutes.docs"
            border
          >
            <el-table-column width="30" fixed>
              <template v-slot="scope">
                <span
                  v-if="scope.row.image"
                  class="icon__money-sm"
                  :style="{
                    'background-image': 'url(' + scope.row.image + ')'
                  }"
                ></span>
              </template>
            </el-table-column>
            <el-table-column
              min-width="130"
              sortable="custom"
              prop="title"
              label="Название"
              fixed
            ></el-table-column>
            <el-table-column
              min-width="130"
              sortable="custom"
              prop="key"
              label="Ключ"
            ></el-table-column>
            <el-table-column
              min-width="130"
              sortable="custom"
              prop="course"
              label="Курс"
            >
              <template v-slot="scope">
                <div>
                  <el-tooltip
                    placement="top"
                    :content="scope.row.course.toFixed(16)"
                    delay="500"
                  >
                    <span>{{
                      new Intl.NumberFormat("ru-RU").format(scope.row.course)
                    }}</span>
                  </el-tooltip>
                </div>
                <div style="font-size: 9px; color: gray; margin-top: 4px;">
                  <el-tooltip
                    placement="top"
                    :content="scope.row.courseSource ? scope.row.courseSource : 'N/A'"
                  >
                    <span>{{
                      scope.row.lastUpdatedAt
                        ? $dayjs(scope.row.lastUpdatedAt).format("DD.MM.YYYY HH:mm:ss")
                        : "N/A"
                    }}</span>
                  </el-tooltip>

                </div>
              </template>
            </el-table-column>
            <el-table-column
              min-width="160"
              sortable="custom"
              prop="minGive"
              label="Мин. покупка"
            ></el-table-column>
            <el-table-column
              min-width="140"
              sortable="custom"
              prop="percentGive"
              label="Покупка %"
            >
              <template v-slot="scope">
                {{
                  scope.row.percentGive
                    ? `${scope.row.percentGive}%`
                    : "Не выставлен"
                }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="145"
              sortable="custom"
              prop="percentGet"
              label="Продажа %"
            >
              <template v-slot="scope">
                {{
                  scope.row.percentGet
                    ? `${scope.row.percentGet}%`
                    : "Не выставлен"
                }}
              </template>
            </el-table-column>
            <el-table-column min-width="160" label="Лимит Покупки">
              <template v-slot="scope">
                {{
                  scope.row.isLimit
                    ? `${scope.row.limitPercentBuy}%`
                    : "Не выставлен"
                }}
              </template>
            </el-table-column>
            <el-table-column min-width="160" label="Лимит Продажи">
              <template v-slot="scope">
                {{
                  scope.row.isLimit
                    ? `${scope.row.limitPercentSell}%`
                    : "Не выставлен"
                }}
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              min-width="130"
              sortable="custom"
              prop="isGive"
              label="Покупаем"
              v-if="session.type === 1 || session.type === -1"
            >
              <template v-slot="scope">
                <el-popconfirm
                  title="Изменить значение покупки?"
                  @confirm="
                    handleValuteSwitch(scope.row, { isGive: !scope.row.isGive })
                  "
                >
                  <el-switch
                    slot="reference"
                    :value="scope.row.isGive"
                  ></el-switch>
                </el-popconfirm>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              min-width="120"
              sortable="custom"
              prop="isGet"
              label="Продаем"
              v-if="session.type === 1 || session.type === -1"
            >
              <template v-slot="scope">
                <el-popconfirm
                  title="Изменить значение продажи?"
                  @confirm="
                    handleValuteSwitch(scope.row, { isGet: !scope.row.isGet })
                  "
                >
                  <el-switch
                    slot="reference"
                    :value="scope.row.isGet"
                  ></el-switch>
                </el-popconfirm>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              min-width="75"
              label=""
              v-if="session.type === 1 || session.type === -1"
            >
              <template v-slot="scope">
                <i
                  class="el-icon-edit edit"
                  @click.prevent="editValuteInModal(scope.row)"
                ></i>
                <el-popconfirm
                  icon="el-icon-delete"
                  icon-color="red"
                  :title="`Удалить валюту '${scope.row.title}'?`"
                  @confirm="removeValute(scope.row)"
                >
                  <i slot="reference" class="el-icon-delete delete"></i>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleValutesPage"
            @size-change="handleValutesLimit"
            :current-page.sync="valutes.page"
            :page-size="valutes.limit"
            layout="sizes, prev, pager, next, jumper"
            :total="valutes.totalDocs"
          >
          </el-pagination>
        </div>
        <div v-else class="text-center">
          Нет данных
        </div>
      </el-card>
    </div>
    <EditValuteComponent />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
//
import EditValuteComponent from "./components/EditValute";
//
export default {
  name: "Main",
  components: { EditValuteComponent },
  data: () => ({
    assets: {},
    activeOptions: [
      { label: "Активная", value: "true" },
      { label: "Не активная", value: "false" }
    ]
  }),

  computed: {
    ...mapState("auth", ["session"]),
    ...mapState("valutes", [
      "valutes",
      "sites",
      "loading",
      "searchString",
      "categories",
      "category",
      "active",
      "isFiltered"
    ]),
    loadingStatus: {
      get() {
        return this.loading;
      },
      set(val) {
        this.changeLoading({ loading: val });
      }
    },
    searchStringFilter: {
      get() {
        return this.searchString;
      },
      set(val) {
        this.changeSearchString({ searchString: val });
      }
    },
    categoryFilter: {
      get() {
        return this.category;
      },
      set(val) {
        this.changeCategory({ category: val });
      }
    },
    activeFilter: {
      get() {
        return this.active;
      },
      set(val) {
        this.changeActive({ active: val });
      }
    }
  },

  methods: {
    ...mapActions("valutes", [
      "editValute",
      "queryPaginationValutes",
      "getSites",
      "getValuteCategories",
      "deleteValute",
      "changeSearchString",
      "changeCategory",
      "changeActive",
      "changeDataInModal",
      "changeDialogVisible",
      "performSearch",
      "resetSearch",
      "goToPage",
      "changeSorting",
      "changeLimit",
      "changeLoading"
    ]),

    addValute() {
      this.changeDataInModal({});
      this.changeDialogVisible({ dialogVisible: true });
    },

    editValuteInModal(valute) {
      this.changeDataInModal({ valuteInModal: { ...valute } });
      this.changeDialogVisible({ dialogVisible: true });
    },

    removeValute(valute) {
      this.deleteValute(valute._id).then(() => {
        this.$nextTick().then(() =>
          this.$message.success("Операция прошла успешно")
        );
      });
    },

    handleValuteSwitch(valute, editedColumns) {
      let editValute = {
        ...valute,
        categories: JSON.stringify(valute.categories),
        ...editedColumns
      };
      //
      this.editValute({ id: valute._id, valute: editValute }).then(() => {
        this.$nextTick().then(() =>
          this.$message.success("Операция прошла успешно")
        );
      });
    },

    handleValutesPage(page) {
      this.goToPage({ page });
    },

    handleValutesLimit(limit) {
      this.changeLimit({ limit });
    },

    handleSortChange(sortData) {
      const sort =
        sortData.order === "ascending"
          ? sortData.prop
          : sortData.order === "descending"
          ? `-${sortData.prop}`
          : "";
      this.changeSorting({ sort });
    }
  },

  async mounted() {
    Promise.all([
      await this.queryPaginationValutes(),
      this.getValuteCategories(),
      this.getSites()
    ]).then(() => {
      return this.$nextTick().then();
    });
  }
};
</script>

<style scoped>
.currency-page >>> input {
  margin-bottom: 0;
}

.currency-page >>> .cell {
  margin-left: 0;
  margin-right: 0;
}

.main-card {
  width: 100%;
  padding: 20px;
}

.main-card >>> .el-card__header {
  padding-bottom: 3px;
}

.el-pagination {
  padding: 15px 5px;
  margin-left: -10px;
}

.delete {
  color: red;
}

.edit {
  color: orange;
  margin-right: 5px;
}

.delete,
.edit {
  font-size: 1.5em;
  cursor: pointer;
}

label {
  display: block;
}

.bottom-space {
  margin-bottom: 15px;
}

.el-form-item {
  margin-bottom: 0;
}

.add-btn {
  float: right;
  position: relative;
  z-index: 2;
}

.text-center {
  text-align: center;
}

.content {
  display: flex;
  justify-content: space-between;
}

.icon__money-sm {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin-left: -10px;
  margin-right: -10px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Valutes/index.vue